import { MegaMenuState } from "./types";

export const initialState: MegaMenuState = {
	isOpen: false
};
